import type { TypedUseSelectorHook } from 'react-redux';
import { useSelector } from 'react-redux';

import { isEmbeddedMode } from '@jane/shared/util';

import type { CustomerReducerState } from './redux/customer';
import type { CustomerState } from './redux/types';

export const useCustomerSelector: TypedUseSelectorHook<CustomerState> =
  useSelector;

export const isEmbeddedModeSelector = ({
  embeddedApp: { appMode },
}: CustomerState) => isEmbeddedMode(appMode);

export const hasUserSelector = ({ id }: CustomerReducerState) => Boolean(id);

export const headlessDisablePrepaymentSelector = (state: CustomerState) =>
  ['bloom', 'headless'].includes(state.embeddedApp.appMode) &&
  state.headlessApp.options?.disablePrepayment;
